export default "__VITE_ASSET__4aeeb04a__"